import axios from "axios";
import Toastify from '../components/Toastify/index'
import { BASEURL } from '../helpers/constantes';
import { getToken,removeToken } from './auth';


 const api = axios.create(
    {
    baseURL: `${window.location.href.includes('localhost') || window.location.href.includes('192.168')? BASEURL:BASEURL+'/'}api/medxsocial/`,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Expose-Headers": "Access-Control-*",
        "Access-Control-Allow-Headers": "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS, HEAD",
        "Access-Control-Allow-Origin": "*",
    }
});
api.interceptors.request.use(

    async function (config) {
        // Do something before request is sent
        const AUTH_TOKEN = getToken();
        config.headers.Authorization = `Bearer ${AUTH_TOKEN}`;

        return config;
    },
    function (error) {
        // Do something with request error
        debugger
        return Promise.reject(error);
    }
);
api.interceptors.response.use(
    async function ( config ) {
        return config;
    },
    function ( error ) {
        // Do something with request error
        if ( error.response ) {
            if ( error.response.status == 403 ) {
                Toastify.error( 'Seu token expirou, faça o login novamente.' );
                removeToken();
                window.location.href= '/'
            } if ( error.response.status == 401 ) {
                Toastify.error( 'Voce não ter permissão' );
                removeToken();
                window.location.href= '/'
            } else {
                Toastify.error( 'Ops, ocorreu um erro na sua solicitação' );
            }
        } else {
            Toastify.error( 'Ops, ocorreu um erro na sua solicitação' );
        }
        return Promise.reject( error );
    }
);

export default api;

